import { useMemo, useState } from "react";
import { reviews } from "@/mocks/reviews";

const filters = ["全部", "结局考据党", "人物党", "治愈系", "主线党", "考据党", "新人友好"];

function ReviewList() {
  const [active, setActive] = useState("全部");

  const list = useMemo(() => {
    if (active === "全部") return reviews;
    return reviews.filter((r) => r.tag === active);
  }, [active]);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-center gap-2">
        {filters.map((f) => (
          <button
            key={f}
            type="button"
            onClick={() => setActive(f)}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
              active === f
                ? "bg-secondary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-800"
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
        {list.map((r) => (
          <article key={r.id} className="rounded-lg border border-background-200/70 bg-background-50 p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className={`flex h-12 w-12 items-center justify-center rounded-full ${r.avatar} font-heading text-lg font-bold`}>
                  {r.author.slice(0, 1)}
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950">{r.author}</h3>
                  <p className="text-xs text-foreground-500">{r.tag} · {r.date}</p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <span className="font-heading text-2xl font-bold text-primary-600">{r.score}</span>
                <span className="text-sm text-foreground-400">/10</span>
              </div>
            </div>
            <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">{r.title}</h4>
            <p className="mt-2 text-sm leading-7 text-foreground-700">{r.content}</p>
            <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1"><i className="ri-thumb-up-line"></i> 有用 {r.likes}</span>
              <span className="inline-flex items-center gap-1"><i className="ri-share-line"></i> 分享</span>
              <span className="inline-flex items-center gap-1"><i className="ri-bookmark-line"></i> 收藏</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ReviewList;